import { useSnackbar } from 'notistack';
import { useCallback } from 'react';

import { client, useFormErrorHandler } from 'core/http';
import { ResetPasswordSchema } from 'core/schemas/resetPassword';

export default function useResetPassword() {
  const { enqueueSnackbar } = useSnackbar();
  const handleFormErrors = useFormErrorHandler();

  const reset = useCallback(
    (payload: ResetPasswordSchema) => {
      return client()
        .post(`auth/password/reset`, payload)
        .then(() =>
          enqueueSnackbar('Salasana vaihdettu', { variant: 'success' })
        )
        .catch(handleFormErrors);
    },
    [enqueueSnackbar, handleFormErrors]
  );

  return reset;
}
